/**
 * Compatibility shim: Material-UI v4 lab `TreeView`/`TreeItem` on @mui/x-tree-view v7.
 *
 * v7 renamed the component to `SimpleTreeView`, moved the expand/collapse icons to
 * `slots`, and renamed `nodeId` -> `itemId` plus the expand/select callbacks.
 * These wrappers translate the legacy props so the two call sites need no edits.
 */
import * as React from 'react';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem as XTreeItem } from '@mui/x-tree-view/TreeItem';

export function TreeView({
  defaultCollapseIcon,
  defaultExpandIcon,
  defaultEndIcon,
  expanded,
  selected,
  onNodeToggle,
  onNodeSelect,
  children,
  ...rest
}: any) {
  const slots: any = {};
  if (defaultCollapseIcon) slots.collapseIcon = () => defaultCollapseIcon;
  if (defaultExpandIcon) slots.expandIcon = () => defaultExpandIcon;
  if (defaultEndIcon) slots.endIcon = () => defaultEndIcon;

  const extra: any = {};
  if (expanded !== undefined) extra.expandedItems = expanded;
  if (selected !== undefined) extra.selectedItems = selected;
  if (onNodeToggle) extra.onExpandedItemsChange = (_e: any, ids: any) => onNodeToggle(_e, ids);
  if (onNodeSelect) extra.onSelectedItemsChange = (_e: any, ids: any) => onNodeSelect(_e, ids);

  return (
    <SimpleTreeView slots={slots} {...extra} {...rest}>
      {children}
    </SimpleTreeView>
  );
}

export function TreeItem({ nodeId, ...rest }: any) {
  return <XTreeItem itemId={rest.itemId ?? nodeId} {...rest} />;
}
